import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import useNotifications from '@lib/hooks/notifications';
import { Slot, For, If, createPage, createComponent } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Loader, Flex, RouterLink, Content, DocumentTitle } = shared;

import styles from './index.module.scss';
import { useAuthStore } from '@/stores/auth'; 
import checkoutApi from '@/apis/drupal/checkout';
import DeveloperLayout from '@/layouts/DeveloperLayout';

const OrderHistoryRow = createComponent('OrderHistoryRow', {}, function OrderHistoryRow ({}, props) {
  return (
    <tr key={props.order.id}>
      <td>
        {props.order.item}
      </td>
      <td>
        {props.order.date}
      </td>
      <td>
        {props.order.price}
      </td>
    </tr>
  );
});

export default createPage('OrderHistoryPage', { styles }, function OrderHistoryPage ({ className }) {
  const { notify } = useNotifications();
  const [ state ] = useAuthStore();
  const router = useRouter();

  // Redirect to login if not logged in
  useEffect(() => {
    if (state.ready && !state.auth) {
      router.replace('/');
      return;
    }
  }, [ state ]);
  
  const [ loadingHistory, setLoadingHistory ] = useState(true);
  const [ orderHistory, setOrderHistory ] = useState([]);

  // Load order history
  useEffect(() => {
    if (state.ready && !state.auth) {
      router.replace('/');
      return;
    }

    if (state.ready && state.auth) {
      (async () => {
        const orderHistory = await checkoutApi.getHistory(state.auth.uid, state.token)
        if (orderHistory.error) {
          notify('There was an error retrieving your order history.');
          setLoading(false);
          return;
        }
        setOrderHistory(orderHistory);
        setLoadingHistory(false);
      })()
    }
  }, [ state ])

  return (
    <>
      <DocumentTitle title='Order History' />

      <DeveloperLayout className={className}>
        {
          If(!state.ready, () => (
            <Loader.Fill large />
          ))
          .ElseIf(state.ready && !!state.auth, () => (
            <Box>
              <Block>
                <Block>
                  <Title>Order History</Title>
                </Block>
                <Block 
                  className='OrderHistoryPage__OrderHistoryList'
                  style={{ position: 'relative' }}
                >
                  {
                    If(loadingHistory, () => (
                      <Flex wide tall alignCenter justifyCenter>
                        <Flex><Loader /></Flex>
                      </Flex>
                    ))
                    .ElseIf(orderHistory.length === 0, () => (
                      <Content className='--textCenter --padMd1'>
                        <p>You haven't purchased any tokens.</p>
                        <p><RouterLink href='/developer/purchase-tokens'>Purchase Tokens</RouterLink></p>
                      </Content>
                    ))
                    .Else(() => (
                      <table>
                        <thead>
                          <tr>
                            <td>Item</td>
                            <td>Date</td>
                            <td>Price</td>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            For(orderHistory, (order, i) => (
                              <OrderHistoryRow key={i} order={order} />
                            ))
                          }
                        </tbody>
                      </table>
                    ))
                    .EndIf()
                    }
                </Block>
              </Block>
            </Box>
          ))
          .EndIf()
        } 
      </DeveloperLayout>
    </>
  )
});
